import axios from "axios";
//import { setBackdropOpen } from "../store/actions/BackdropActions";
//import { useDispatch } from "react-redux";

const instance = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
});

instance.interceptors.request.use((config) => {
    const token = JSON.parse(localStorage.getItem("okta-token-storage"));
    config.headers.Authorization = token && token.accessToken ? `Bearer ${token.accessToken.accessToken}` : "";
    config.headers.Language = localStorage.getItem("i18nextLng");

    const plantId = localStorage.getItem("plantId");
    if (plantId) config.headers.PlantId = localStorage.getItem("plantId");

    return config;
});

instance.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 403) {
            const forbiddenMessage =
                error.response.data?.Message || error.response.data?.message || "";
            try {
                if (forbiddenMessage) {
                    localStorage.setItem("forbiddenMessage", forbiddenMessage);
                }
            } catch (storageError) {
                // ignore storage errors
            }
            window.location.href = "/noauth";
        }
        return Promise.reject(error);
    }
);

export default instance;
